import { dataLandingPageSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLandingPageSolid = /*#__PURE__*/createIcon(dataLandingPageSolid)
export default IconLandingPageSolid
